export default __webpack_public_path__ + "static/media/slide1-blur.9e6c9673.jpg";